var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-screen"},[_c('img',{ref:"bmnLoaderImg",attrs:{"id":"bmn-loader-img","src":require("../assets/images/bmn_loader.png")}}),_c('h3',[_vm._v("Laden...")])])}
var staticRenderFns = []

export { render, staticRenderFns }